'use client'

import classnames from 'classnames'
import styles from './FeatureSpotlightItem.module.scss'
import SanityImage from '@/components/SanityImage/SanityImage'
import Link from '@/components/Link/Link'
import Widont from '@/components/Widont/Widont'
import { DOC_TYPES } from '@/data'

type FeatureSpotlightItemProps = {
  dish: SanityPage
  className?: string
}

const FeatureSpotlightItem = ({ className, dish }: FeatureSpotlightItemProps) => {
  const { menuItemData, title, slug } = dish
  const image = menuItemData?.lifestyleImages?.[0]

  if (!image || !slug?.current) return null

  return (
    <article className={classnames(styles.FeatureSpotlightItem, className)}>
      <Link
        link={{
          linkType: 'internal',
          link: {
            slug: slug.current,
            _type: DOC_TYPES.MENU_ITEM,
          },
        }}
        className={styles.linkContainer}
      >
        <div className={styles.imageContainer}>
          <SanityImage
            image={image}
            breakpoints={{
              tablet: {
                width: 1100,
                image,
              },
              xs: {
                width: 700,
                image,
              },
            }}
            className={styles.image}
          />
        </div>
        <div className={styles.textContent}>
          <h3 className={styles.itemTitle}>
            <Widont text={title} />
          </h3>
          {menuItemData?.description && (
            <p className={styles.description}>
              <Widont text={menuItemData.description} />
            </p>
          )}
        </div>
      </Link>
    </article>
  )
}

FeatureSpotlightItem.displayName = 'FeatureSpotlightItem'

export default FeatureSpotlightItem
